// Extracted from DeveloperPage so more than one screen can copy a value.

const fallbackCopyWithTextArea = (value: string): boolean => {
    // Fallback for contexts without the Clipboard API.
    const textarea = document.createElement('textarea');
    textarea.value = value;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'absolute';
    textarea.style.left = '-9999px';

    document.body.appendChild(textarea);
    textarea.select();
    const copied = document.execCommand('copy');
    document.body.removeChild(textarea);

    return copied;
};

// Resolves false rather than rejecting, so callers can report a failed copy.
export const copyTextToClipboard = async (value: string): Promise<boolean> => {
    // The Clipboard API works only in secure contexts.
    if (
        window.isSecureContext &&
        navigator?.clipboard &&
        navigator.clipboard.writeText
    ) {
        try {
            await navigator.clipboard.writeText(value);
            return true;
        } catch {
            return false;
        }
    }

    return fallbackCopyWithTextArea(value);
};
